import React from 'react';
import { submitQueriesStream } from '@services/genaiQueriesV2';
import { logFormSubmit } from '@utils/usefulFuncs';
import { TrackingEvent } from '@classes/TrackingEvent';
import { addAdvancedSettingValues } from '../application/useAdvancedSettings';

const ACTIONS = {
  init: 'init',
  clear: 'clear',
  update: 'u',
};

const initState = {
  resultId: null,
  isSubmittingToApi: false,
  formError: null,
};

function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.init: {
      return { ...state, ...action.payload };
    }
    case ACTIONS.clear: {
      return { ...state, ...initState };
    }

    case ACTIONS.update: {
      return { ...state, ...action.payload };
    }

    default:
      throw new Error('missing case: useCustomPromptSeries');
  }
}

export const useCustomPromptSeries = (prompts, docList, settings) => {
  const [state, dispatch] = React.useReducer(reducer, initState, () => initState);

  React.useEffect(() => {
    let cancelStatus = { isCancelled: false };

    const onSubmit = async () => {
      const { model } = settings;

      dispatch({
        type: ACTIONS.update,
        payload: { prompts, docList },
      });

      const v2Settings = { user_mode: settings?.user_mode, include_context: true };
      addAdvancedSettingValues(settings, v2Settings);
      const docIds = docList.map((d) => d.id);
      const v2Questions = prompts.map((p) => ({ question: p.prompt }));

      logFormSubmit({ ...v2Settings, questions: v2Questions, doc_ids: docIds });

      TrackingEvent.create('Asked Digital Analyst Question Series', {
        'Question List': prompts.map((p) => p.prompt),
        Model: model,
      });

      dispatch({
        type: ACTIONS.update,
        payload: {
          isSubmittingToApi: true,
          resultId: null,
          formError: null,
        },
      });

      const result = await submitQueriesStream({
        questions: v2Questions,
        docIds,
        settings: v2Settings,
      });
      if (cancelStatus.isCancelled) return;

      if (result.status === 200) {
        dispatch({
          type: ACTIONS.update,
          payload: {
            isSubmittingToApi: false,
            resultId: result.runId,
            formError: null,
          },
        });
        return true;
      } else {
        dispatch({
          type: ACTIONS.update,
          payload: {
            isSubmittingToApi: false,
            resultId: null,
            formError: result.error || 'Something went wrong, try again.',
          },
        });
        return false;
      }
    };

    onSubmit();
    return () => {
      dispatch({
        type: ACTIONS.clear,
      });
      cancelStatus.isCancelled = true;
    };
  }, [prompts, docList, settings]);

  return state;
};
